var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetric3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#C4E9FD",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.886 49.9999C14.8495 49.9999 13.9847 49.6534 13.2917 48.9604C12.5987 48.2674 12.2515 47.4019 12.25 46.3639V24.386C12.25 23.3495 12.5972 22.4847 13.2917 21.7917C13.9862 21.0987 14.8502 20.7515 15.8837 20.75H25.75V17.6337C25.75 16.5987 26.0972 15.734 26.7917 15.0395C27.4862 14.345 28.351 13.9985 29.386 14H35.6162C36.6512 14 37.5159 14.3465 38.2104 15.0395C38.9049 15.7325 39.2514 16.5972 39.2499 17.6337V20.75H49.1162C50.1512 20.75 51.0152 21.0972 51.7082 21.7917C52.4012 22.4862 52.7484 23.351 52.7499 24.386V46.3662C52.7499 47.4012 52.4027 48.2659 51.7082 48.9604C51.0137 49.6549 50.1497 50.0014 49.1162 49.9999H15.886ZM28 20.75H36.9999V17.6337C36.9999 17.2887 36.8559 16.9715 36.5679 16.682C36.2799 16.3925 35.9627 16.2485 35.6162 16.25H29.3837C29.0387 16.25 28.7215 16.394 28.432 16.682C28.1425 16.97 27.9985 17.2872 28 17.6337V20.75Z",
    fill: "#003AD4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetric3);
export default __webpack_public_path__ + "static/media/metric3.57a900843a92463df9e921a857689c07.svg";
export { ForwardRef as ReactComponent };